var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.readyRender
    ? _c(
        "div",
        {
          staticClass: "selfdefine-card",
          attrs: { "data-spm": "selfdefine-card" },
        },
        [
          _c("iframe", {
            attrs: {
              src: _vm.iframe_url,
              height: _vm.pc_height,
              width: _vm.pc_width,
              "data-spm-type": "content",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }